import { useSectionFieldsValidation } from './useSectionFieldsValidation';
import { useBirthdayValidation } from './useBirthdayValidation';
import scroll from 'utilities/scroll';
import { useSecondLastNameValidation } from './useSecondLastNameValidation';
import { useResidentValidation } from './useResidentValidation';
import { useInvitationDocNumberValidation } from './useInvitationDocNumberValidation';
import { useEffect, useState } from 'react';

export const usePersonalDataValidations = ({
    userProfile,
    userProfileForm,
    formActions,
    isValidatingTin,
    isPassportRequired,
    isResident,
    handleValidateSection,
    handleAdviseShown,
}) => {
    const [showResidentAdvise, setShowResidentAdvise] = useState(false);
    const [showTooYoungAdvise, setShowTooYoungAdvise] = useState(false);
    const [shownIsVulnerablyOlder, setShownIsVulnerablyOlder] = useState(false);
    const [showJointHolderDocAdvise, setShowJointHolderDocAdvise] = useState(false);
    const { isFormWithErrors, onValidateSection } = useSectionFieldsValidation({
        userProfile,
        userProfileForm,
        formActions,
        isValidatingTin,
        isPassportRequired,
        handleValidateSection,
    });
    const { isValidDate, handleValidateBirthDate } = useBirthdayValidation({
        userProfile,
        formActions,
        handleIsOlder: isOlder => {
            if (!isOlder) {
                setShowTooYoungAdvise(true);
                setShowResidentAdvise(false);
                setShowJointHolderDocAdvise(false);
                const ageDisclosureElement = document.getElementById('ageRestriction');
                scroll.transition(ageDisclosureElement, 'top');
            } else {
                setShowTooYoungAdvise(false);
            }
        },
        handleIsVulnerablyOlder: isVulnerablyOlder => {
            setShownIsVulnerablyOlder(isVulnerablyOlder);
            if (isVulnerablyOlder) {
                setShowTooYoungAdvise(false);
                setShowResidentAdvise(false);
                setShowJointHolderDocAdvise(false);
            }
        },
    });
    const { handleSecondLastNameValidation } = useSecondLastNameValidation({ userProfile, formActions });
    const { handleValidateResident } = useResidentValidation({ setShowResidentAdvise });
    useInvitationDocNumberValidation({
        userProfile,
        userProfileForm,
        onValidation: isValidDocNumberMatch => {
            setShowJointHolderDocAdvise(!isValidDocNumberMatch);
            setShowTooYoungAdvise(isValidDocNumberMatch && userProfile.isOlder === false);
            setShowResidentAdvise(isValidDocNumberMatch && userProfile.resident && !isResident);
        },
    });

    useEffect(() => {
        handleAdviseShown(
            showJointHolderDocAdvise || showResidentAdvise || showTooYoungAdvise || shownIsVulnerablyOlder
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showJointHolderDocAdvise, showResidentAdvise, showTooYoungAdvise, shownIsVulnerablyOlder]);

    return {
        onValidateSection,
        handleValidateBirthDate,
        handleSecondLastNameValidation,
        handleValidateResident,
        isFormWithErrors,
        isValidDate,
        showResidentAdvise,
        showTooYoungAdvise,
        showJointHolderDocAdvise,
        shownIsVulnerablyOlder,
    };
};
